import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetParishesByMunicipality() {
    const [getParishesIsLoading, setGetParishesIsLoading] = useState(false);
    const [getParishesError, setGetParishesError] = useState(null);
    const [parishes, setParishes] = useState([]);

    // Get the Parishes by Municipality

    const handleGetParishesByMunicipality = useCallback(async (municipality) => {
        setGetParishesIsLoading(true);
        setGetParishesError(null);

        try {

            const parishesRequest = await OptionsService.getParishiesByMunicipality(municipality);

            setGetParishesIsLoading(false);
            setParishes(parishesRequest?.data?.data);

        } catch(error) {

            setGetParishesIsLoading(false);
            setGetParishesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getParishesIsLoading,
        getParishesError,
        parishes,
        handleGetParishesByMunicipality,
        setParishes,
    }
}
